import { useEffect } from "react";

function App() {
  useEffect(() => {
    window.location.href = "https://stacstart.us/";
  }, []);

  return null;
}

export default App;

// eslint-disable react-hooks/exhaustive-deps
// import { lazy, Suspense, useEffect, useState, startTransition } from "react";
// import { BrowserRouter, Routes, Route } from "react-router-dom";
// import axios from "axios";
//
// import Logo from "assets/svg/logo.svg";
//
// // toast
// import { ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
//
// // pages
// import Preload from "ui/preload";
// import HomePage from "pages/home";
// import Successful from "pages/individual-trainings/success";
// import ViewProjectPage from "pages/student-projects/[idd]";
//
// const AboutPage = lazy(() => import("pages/about"));
// const ContactPage = lazy(() => import("pages/contact"));
// const TalentsPage = lazy(() => import("pages/talent"));
// const ResumePage = lazy(() => import("pages/resume"));
// const WebinarPage = lazy(() => import("pages/webinar"));
//
// // corporate training
// const CustomTrainingsPage = lazy(
//   () => import("pages/corporate-trainings/custom-training")
// );
// const CalendarTrainingsPage = lazy(
//   () => import("pages/corporate-trainings/calendar-training")
// );
//
// // individual training
// const AIPython = lazy(() => import("pages/individual-trainings/ai-python"));
// const CloudAws = lazy(() => import("pages/individual-trainings/cloud-aws"));
// const CloudAzure = lazy(() => import("pages/individual-trainings/cloud-azure"));
// const CyberSecurity = lazy(
//   () => import("pages/individual-trainings/cyber-security")
// );
// const DataAnalytics = lazy(
//   () => import("pages/individual-trainings/data-analytics")
// );
// const DataScience = lazy(
//   () => import("pages/individual-trainings/data-science")
// );
// const Dbms = lazy(() => import("pages/individual-trainings/dbms"));
// const GenerativeAI = lazy(
//   () => import("pages/individual-trainings/generative-ai")
// );
// const ProductManagement = lazy(
//   () => import("pages/individual-trainings/product-management")
// );
// const UiUx = lazy(() => import("pages/individual-trainings/ui-ux"));
//
// // helpers
// const ScrollToTop = lazy(() => import("helpers/scrollToTop"));
// const TalentRequest = lazy(() => import("pages/talent/request"));
// const SubmitResume = lazy(() => import("pages/resume/submit"));
// const Custom = lazy(() => import("pages/corporate-trainings/custom"));
// const EnrollmentForm = lazy(
//   () => import("pages/individual-trainings/enrollment")
// );
//
// // documents
// const Privacy = lazy(() => import("pages/documents/privacy"));
// const Refund = lazy(() => import("pages/documents/refund"));
// const StudentCode = lazy(() => import("pages/documents/student-code"));
// const TutorCode = lazy(() => import("pages/documents/tutor-code"));
// const Terms = lazy(() => import("pages/documents/terms"));
//
// // project
// const ProjectPage = lazy(() => import("pages/student-projects"));
// // const ViewProjectPage= lazy(()=> import("pages/student-projects/index"))
// // scholarship
// const Scholarship = lazy(() => import("pages/scholarship"));
//   const ScholarshipTechleap = lazy(() => import("pages/scholarship/techleap"));
//
// function App() {
//   const queryParams = new URLSearchParams(window.location.search);
//   const role = queryParams.get("role");
//
//   const [loading, setLoading] = useState(true);
//   const [userCountry, setCountry] = useState<null | any>(null);
//
//   useEffect(() => {
//     if (!userCountry) {
//       setLoading(true);
//
//       axios
//         .get(
//           "https://api.ipgeolocation.io/ipgeo?apiKey=73eb2543491e4b24950ccdcfae953f68",
//           { timeout: 10000 }
//         )
//         .then((data) => {
//           startTransition(() => {
//             setCountry(data?.data);
//             if (role?.toLowerCase() === "admin") {
//               setLoading(false);
//             } else if (data?.data?.continent_name === "Africa") {
//               window.location.href = "https://conclaseacademy.com";
//               // setLoading(false)
//             } else {
//               setLoading(false);
//             }
//           });
//         })
//         .catch((error) => {
//           console.error(error);
//           setLoading(false);
//         });
//     }
//   }, [userCountry]);
//
//   return (
//     <BrowserRouter>
//       <ScrollToTop />
//       <Preload />
//       <Suspense
//         fallback={
//           <div className="fixed top-0 left-0 w-full h-screen flex items-center justify-center bg-white z-[100]">
//             <img src={Logo} alt="" className="object-contain w-60" />
//           </div>
//         }
//       >
//         {loading ? (
//           <div className="fixed top-0 left-0 w-full h-screen flex items-center justify-center bg-white z-[100]">
//             <img src={Logo} alt="" className="object-contain w-60" />
//           </div>
//         ) : (
//           <Routes>
//             <Route path="/" element={<HomePage />} />
//             <Route path="*" element={<HomePage />} />
//
//             <Route path="/about" element={<AboutPage />} />
//             <Route path="/contact" element={<ContactPage />} />
//
//             <Route path="/talents" element={<TalentsPage />} />
//             <Route path="/talents/request" element={<TalentRequest />} />
//
//             <Route path="/resumes" element={<ResumePage />} />
//             <Route path="/resumes/submit" element={<SubmitResume />} />
//
//             <Route path="/webinar" element={<WebinarPage />} />
//               <Route path="/student-projects" element={<ProjectPage />} />
//               <Route path="/student-projects/:idd" element={ <ViewProjectPage/>}/>
//             {/* Individual Training */}
//             <Route path="/generative-ai" element={<GenerativeAI />} />
//             <Route path="/ai-engineering" element={<AIPython />} />
//             <Route path="/cloud-aws" element={<CloudAws />} />
//             <Route path="/cloud-azure" element={<CloudAzure />} />
//             <Route path="/cyber-security" element={<CyberSecurity />} />
//             <Route path="/data-analytics" element={<DataAnalytics />} />
//             <Route path="/data-science" element={<DataScience />} />
//             <Route path="/dbms" element={<Dbms />} />
//             <Route path="/project-management" element={<ProductManagement />} />
//             <Route path="/ui-ux" element={<UiUx />} />
//             <Route path="/apply" element={<EnrollmentForm />} />
//
//             {/* Corporate Training */}
//             <Route
//               path="/enterprise-custom-training"
//               element={<CustomTrainingsPage />}
//             />
//             <Route
//               path="/corporate-calendar-training"
//               element={<CalendarTrainingsPage />}
//             />
//             <Route path="/custom-training" element={<Custom />} />
//
//             {/* Document Page */}
//             <Route path="/privacypolicy" element={<Privacy />} />
//             <Route path="/refundpolicy" element={<Refund />} />
//             <Route path="/studentcodeofconduct" element={<StudentCode />} />
//             <Route path="/instructorcodeofconduct" element={<TutorCode />} />
//             <Route path="/terms&conditions" element={<Terms />} />
//
//             {/* Success Page */}
//             <Route path="/success" element={<Successful />} />
//
//             {/* Scholarship */}
//               <Route path="/scholarship" element={<Scholarship />} />
//               <Route path="/scholarship/techleap" element={<ScholarshipTechleap />} />
//           </Routes>
//         )}
//       </Suspense>
//
//       <ToastContainer />
//     </BrowserRouter>
//   );
// }
//
// export default App;
